import { Box, Typography } from '@mui/material'

import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import GradientBox from '@ecm/ui/element/GradientBox'
import MainContainer from '@ecm/ui/element/MainContainer'

import mailDoneIcon from '/public/images/icon/mail_done.svg'

const VirtualMailboxBanner = () => (
  <Box
    mt="6em"
    p="2em 0"
    sx={{
      background: `linear-gradient(to bottom, transparent 50%, ${Color.smoke.normal} 50%)`,
    }}
  >
    <MainContainer>
      <GradientBox position="relative">
        <Typography
          variant="h6"
          m={{ md: '0.35em 0', xs: '3.5em 0 0 0' }}
          maxWidth={{ md: '500px', xs: 'unset' }}
          textAlign={{ md: 'unset', xs: 'center' }}
        >
          Thousands of companies have trusted us with over 23 million pieces of mail and $4.6
          billion in checks.
        </Typography>
        <Box
          position="absolute"
          bottom={{ md: '-3px', xs: 'unset' }}
          top={{ md: 'unset', xs: '-100px' }}
          right={{ lg: '5em', md: '4em', xs: '50%' }}
          sx={{
            transform: { md: 'unset', xs: 'translateX(50%)' },
          }}
        >
          <CloudflareImage src={mailDoneIcon} />
        </Box>
      </GradientBox>
    </MainContainer>
  </Box>
)

export default VirtualMailboxBanner
